module.exports = __webpack_public_path__ + "static/media/logo.431b110d.png";